import './styles.scss'
import React, { useState, useEffect } from 'react'

const PreviewAppResource = (props) => {
  const { url, targetOrientation, targetSize, acceptTypes, resourcePreviewRef, reset, prop, primaryColor, requireLogo, companyLogo, defaultCompanyLogo, removeResource, previewResource, videoControls } = props
  const [previewDimensions, setPreviewDimensions] = useState({})

  useEffect(() => {
    getImageScaleForPreview({ url, targetOrientation, targetSize })
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const getImageScaleForPreview = ({ url, targetOrientation, targetSize }) => {
    let width
    let height
    let scale = 1

    let img = new Image()
    img.src = url
    img.addEventListener("load", function() {
      width = this.naturalWidth
      height = this.naturalHeight

      if (targetOrientation === 'width') {
        let scaledWidth = width

        while (scaledWidth > targetSize) {
          scaledWidth = width
          scale -= 0.01
          scaledWidth *= scale
        }
      }

      if (targetOrientation === 'height') {
        let scaledHeight = height

        while (scaledHeight > targetSize) {
          scaledHeight = height
          scale -= 0.01
          scaledHeight *= scale
        }
      }

      setPreviewDimensions({
        width,
        height,
        scale
      })
    })
  }

  return(
    <div className='preview' style={{
      width: !acceptTypes.includes('video') ? `calc(${previewDimensions.width}px * ${previewDimensions.scale})` : null,
      height: !acceptTypes.includes('video') ? `calc((${previewDimensions.height}px * ${previewDimensions.scale}) + ${!removeResource ? '40px' : '0px'})` : null
    }}>
      {removeResource && <i className='preview__remove' onClick={removeResource}></i>}
      <div style={{
        width: !acceptTypes.includes('video') ? `${previewDimensions.width}px` : null,
        height: !acceptTypes.includes('video') ? `${previewDimensions.height}px` : null,
        marginLeft: !acceptTypes.includes('video') && !removeResource ? `calc((450px - (${previewDimensions.width}px * ${previewDimensions.scale})) / 2)` : null,
        padding: acceptTypes.includes('video') && !removeResource ? '20px' : null,
        transform: !acceptTypes.includes('video') ? `scale(${previewDimensions.scale})` : null,
        transformOrigin: !acceptTypes.includes('video') ? `0 ${!removeResource ? '20px' : '0'}` : null
      }}>
        <div ref={resourcePreviewRef} style={{
          width: !acceptTypes.includes('video') ? `${previewDimensions.width}px` : null,
          height: !acceptTypes.includes('video') ? `${previewDimensions.height}px` : null,
          backgroundColor: !reset && !acceptTypes.includes('video') && !prop.includes('splash') && !prop.includes('logo') ? primaryColor : null
        }}>
          {acceptTypes.includes('video') ? (
            <video className='preview__resource' controls={videoControls} controlsList="nodownload" onClick={previewResource} style={{ cursor: removeResource ? 'pointer' : 'default' }}>
              <source src={url} type={acceptTypes} />
            </video>
          ) : (
            <div className='preview__resource' onClick={previewResource} style={{ position: requireLogo ? 'relative' : null, cursor: removeResource ? 'pointer' : 'default' }}>
              {requireLogo && !reset && (
                <div className='preview__logo-wrapper' style={{
                  width: prop.includes('splash')
                  || prop.includes('appScreenAndroid1')
                  || prop.includes('appScreenTablet71')
                  || prop.includes('appScreenTablet101')
                  || prop.includes('appScreenIos551')
                  || prop.includes('appScreenIos651')
                    ? '400px'
                    : prop.includes('functionGraphic')
                      ? 'auto'
                      : null,
                  height: prop.includes('splash')
                  || prop.includes('appScreenAndroid1')
                  || prop.includes('appScreenTablet71')
                  || prop.includes('appScreenTablet101')
                  || prop.includes('appScreenIos551')
                  || prop.includes('appScreenIos651')
                    ? '400px'
                    : prop.includes('functionGraphic')
                      ? '50px'
                      : null,
                  position: requireLogo ? 'absolute' : null,
                  top: prop.includes('splash')
                    ? 'calc(50% - 200px)'
                    : prop.includes('appScreenAndroid1')
                    || prop.includes('appScreenTablet71')
                    || prop.includes('appScreenTablet101')
                      ? '550px'
                      : prop.includes('appScreenIos551')
                      || prop.includes('appScreenIos651')
                        ? '500px'
                        : prop.includes('functionGraphic')
                          ? '25px'
                          : null,
                  left: prop.includes('splash')
                  || prop.includes('appScreenAndroid1')
                  || prop.includes('appScreenTablet71')
                  || prop.includes('appScreenTablet101')
                  || prop.includes('appScreenIos551')
                  || prop.includes('appScreenIos651')
                    ? 'calc(50% - 200px)'
                    : prop.includes('functionGraphic')
                      ? '25px'
                      : null
                }}>
                  <img className='preview__logo' src={companyLogo ? companyLogo : defaultCompanyLogo } alt='Company logo' style={{
                    width: prop.includes('functionGraphic') ? 'auto' : '100%',
                    height: prop.includes('functionGraphic') ? '100%' : 'auto'
                  }} />
                </div>
              )}
              <img src={url} alt='Preview' />
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export default PreviewAppResource
